import { render } from "./ddp.vue?vue&type=template&id=7028f90e&scoped=true"
import script from "./ddp.vue?vue&type=script&lang=js"
export * from "./ddp.vue?vue&type=script&lang=js"

import "./ddp.vue?vue&type=style&index=0&id=7028f90e&scoped=true&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7028f90e"]])

export default __exports__